<div
  class="mvss-service-config"
  [class.narrow-layout]="isNarrowLayout()"
>
  <div class="service-header mb-3">
    <h3 class="service-title">VSS Service Configuration</h3>
    <p class="service-subtitle text-muted">Vulnerability Scanning Service Setup</p>
  </div>

  <form
    [formGroup]="mvssForm"
    class="row g-3"
  >
    <!-- Service Selection Section -->
    <div class="col-12">
      <div class="config-section">
        <h5 class="section-title mb-3">Select VSS Service</h5>
        <div class="row g-3">
          @for (service of vssServiceOptions; track service.value) {
            <div
              class="col-12"
              [class.col-xl-6]="!isNarrowLayout()"
            >
              <div
                class="service-option-card"
                [class.selected]="isServiceSelected(service.value)"
                (click)="selectService(service.value)"
                style="cursor: pointer"
              >
                <div class="service-option-header">
                  <h6 class="service-name">{{ service.text }}</h6>
                </div>
                <p class="service-description">{{ service.description }}</p>
                <div class="selection-indicator">
                  @if (isServiceSelected(service.value)) {
                    <span class="selected-text">Selected</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Always-visible field -->
    <div class="col-12">
      <div class="config-section">
        <h5 class="section-title mb-3">Total Number Of Machines</h5>
        <div class="row g-3">
          <div
            class="col-12"
            [class.col-lg-6]="!isNarrowLayout()"
          >
            <kendo-formfield>
              <kendo-label
                [for]="totalMachines"
                text="Total Number Of Machines *"
              ></kendo-label>
              <kendo-numerictextbox
                formControlName="totalMachines"
                #totalMachines
                [min]="1"
                placeholder="Enter number of machines"
                class="w-100"
              ></kendo-numerictextbox>
              <kendo-formhint>Enter the total number of machines to be scanned</kendo-formhint>
              @if (mvssForm.get('totalMachines')?.invalid && mvssForm.get('totalMachines')?.touched) {
                <kendo-formerror>Total machines is required and must be at least 1</kendo-formerror>
              }
            </kendo-formfield>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
